import React, { FC, useContext, useMemo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import ResourceDecoratorContext from '../#ResourceDecoratorContext';
import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';
import { ResourceComposedProps } from './Resource';

export default function withResourceDecorator<Data, Error = {}>(WrappedComponent: FC<ResourceComposedProps<Data, Error>>) {
  const WithResourceDecorator = ({ requestResolvers = [], ...props }: ResourceComposedProps<Data, Error>) => {
    const { requestResolvers: contextResolvers = [] } = useContext(ResourceDecoratorContext) || {};

    const mergedResolvers = useMemo(() => [
      ...requestResolvers,
      ...contextResolvers,
    ], [contextResolvers, requestResolvers]);

    return (
      <WrappedComponent
        {...props}
        requestResolvers={mergedResolvers}
      />
    );
  };

  WithResourceDecorator.displayName = getWrappedDisplayName('WithResourceDecorator', WrappedComponent);

  return hoistNonReactStatics(WithResourceDecorator, WrappedComponent);
}
